<template>
  <span v-if="noLink">
    <span v-if="showColor" :class="{[location.colorCategoryName + '--text']:true}" class="text--darken-2">
      {{ location.name }}
    </span>
    <span v-else class="text--darken-2">
      {{ location.name }}
    </span>
  </span>
  <span v-else>
    <span v-if="showColor" :class="{[location.colorCategoryName + '--text']:true}" class="text--darken-2">
      <router-link style="color: inherit;" :to="{ name: 'worksiteShow', params: { worksiteId: location.worksiteId } }">
        {{ location.name }}
      </router-link>
    </span>
    <span v-else class="text--darken-2">
      <router-link style="color: inherit;" :to="{ name: 'worksiteShow', params: { worksiteId: location.worksiteId } }">
        {{ location.name }}
      </router-link>
    </span>
  </span>
</template>

<script>
export default {
  name: 'LocationName',
  props: {
    'location': Object,
    'showColor': Boolean,
    noLink: Boolean
  },
}
</script>
